import { API } from "../auth/authApi";

export const getApiKeysApi = () => {
  return API.get("/api-key");
};

export const createApiKeyApi = (data) => {
  return API.post("/api-key", data);
};

export const updateApiKeyStatusApi = (apiKeyId) => {
  return API.put(`/api-key/${apiKeyId}/status`);
};
